module.exports = __webpack_public_path__ + "static/img/preview-05.e0c9c2f5.webp";